export class SearchNewController {
  public static $inject = ['$rootScope', '$scope'];
  public searchText: string;

  constructor(
    private $rootScope: ng.IRootScopeService,
    private $scope: ng.IScope
  ) {
  }
}